import { createContext, useContext } from 'react';

import { CATALOGS, type Catalog } from './index';

/** The catalog of the current UI language; App.tsx provides it. */
export const StringsContext = createContext<Catalog>(CATALOGS.tr);

export function useStrings(): Catalog {
  return useContext(StringsContext);
}
